/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCreateSupplierProduct
 */
export interface MelcoModelsCreateSupplierProduct {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateSupplierProduct
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateSupplierProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateSupplierProduct
     */
    code?: string | null;
}

export function MelcoModelsCreateSupplierProductFromJSON(json: any): MelcoModelsCreateSupplierProduct {
    return MelcoModelsCreateSupplierProductFromJSONTyped(json, false);
}

export function MelcoModelsCreateSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCreateSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function MelcoModelsCreateSupplierProductToJSON(value?: MelcoModelsCreateSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier_id': value.supplier_id,
        'name': value.name,
        'code': value.code,
    };
}


